import { Button } from "../button/button.component";
import { Modal } from "./modalContainer.component";

export const ConfirmationModal = ({
  ref,
  onConfirm,
  confirmationLabel = "confirm",
  children,
}: ConfirmationModalProps) => {
  return (
    <Modal ref={ref}>
      <div className="flex flex-col gap-6 md:px-4">
        {children}
        <footer>
          <form method="dialog" className="flex gap-4 py-2">
            <Button type="submit" secondary border className="w-full uppercase">
              Cancel
            </Button>
            <Button
              type="submit"
              secondary
              className="w-full uppercase"
              onClick={onConfirm}>
              {confirmationLabel}
            </Button>
          </form>
        </footer>
      </div>
    </Modal>
  );
};

export type ConfirmationModalProps = {
  ref?: React.RefObject<HTMLDialogElement | null>;
  children: React.ReactNode;
  confirmationLabel?: string;
  onConfirm: () => void;
};
